import { useState } from 'react';
import { useIntl } from 'react-intl';
import Lookup from 'src/componentes/select2';
import useAuth from 'src/hooks/useAuth';

const ValidacaoEstagioStageGateLookup = ({ ...rest }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const [options] = useState([
    {
      id: 1,
      nome: intl.formatMessage({ id: 'aprovarStageGate' }),
      descricao: intl.formatMessage(
        { id: 'stageGateAprovarDescricao' },
        { projeto: resources.projeto }
      ),
      key: 'approve',
    },
    {
      id: 2,
      nome: intl.formatMessage({ id: 'revisar' }),
      descricao: intl.formatMessage({ id: 'stageGateRevisarDescricao' }),
      key: 'review',
    },
    {
      id: 3,
      nome: intl.formatMessage({ id: 'suspenderStageGate' }),
      descricao: intl.formatMessage(
        { id: 'stageGateSuspenderDescricao' },
        { projeto: resources.projeto }
      ),
      key: 'suspend',
    },
    {
      id: 4,
      nome: intl.formatMessage({ id: 'reprovarStageGate' }),
      descricao: intl.formatMessage(
        { id: 'stageGateReprovarDescricao' },
        { projeto: resources.projeto }
      ),
      key: 'reject',
    },
  ]);

  const customStyle = {
    option: (base, state) => ({
      ...base,
      color: state.isSelected ? '#1e2022' : '#1e2022',
      backgroundColor: state.isSelected ? '#dae1eb' : state.isFocused ? '#ebf5ff' : 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#dae1eb',
      },
    }),
  };

  const lookupRenderDescricao = ({ data }, isOption) => {
    if (!data) return null;

    return isOption ? (
      <div>
        <div className="d-flex align-items-center">
          <span className={data.disabled ? 'text-muted' : 'font-weight-bold'}>
            {data.nome}
          </span>
        </div>
        {data.descricao && (
          <div className="overflow-hidden line-clamp-2 text-sm text-muted">
            {data.descricao}
          </div>
        )}
      </div>
    ) : (
      data?.nome
    );
  };

  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      options={options}
      valueComponent={lookupRenderDescricao}
      customStyle={customStyle}
      {...rest}
    />
  );
};

export default ValidacaoEstagioStageGateLookup;
